module.exports = __webpack_public_path__ + "media/ask/logo-text-white-38dffc07.svg";